export const WATERMARK_PREVIEW_SIZE = 500
